module.exports = __webpack_public_path__ + "img/siji.b4e64f0d.png";